import i18next from 'i18next';

/** Keep the exact database token beside the Date used for display. */
export function recipeWriteVersion(snapshot: { updatedAt: Date; updatedAtToken?: string }): string {
  return snapshot.updatedAtToken ?? snapshot.updatedAt.toISOString();
}

export class StaleRecipeWriteError extends Error {
  constructor() {
    super(i18next.t('costPrice.staleWrite'));
    this.name = 'StaleRecipeWriteError';
  }
}

/** Refresh read models only. Never retry an array derived from a stale snapshot. */
export async function staleRecipeWriteError(): Promise<StaleRecipeWriteError> {
  const [{ useCostPriceStore }, { useSubrecipesStore }, { useSourceRestaurantDataStore }] = await Promise.all([
    import('../stores/appCostPriceStore'),
    import('../stores/appSubrecipesStore'),
    import('../stores/appSourceRestaurantDataStore'),
  ]);
  useSourceRestaurantDataStore.getState().clear();
  await Promise.allSettled([
    useCostPriceStore.getState().reload(),
    useSubrecipesStore.getState().reload(),
  ]);
  return new StaleRecipeWriteError();
}
